import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment';
import jwt_decode from 'jwt-decode';
declare let google: any;

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private readonly http: HttpClient,
    private readonly jwtHelper: JwtHelperService,
    private readonly router: Router
  ) {}
  isTokenExpired() {
    const token = JSON.parse(localStorage.getItem('currentUser')!)?.credential!;
    let isExpired: any = true;
    try {
      isExpired = token != null && this.jwtHelper.isTokenExpired(token);
    } catch (e) {
      isExpired = true;
    }
    return isExpired;
  }

  logoutWithGoogle(message?: string): void {
    google.accounts.id.disableAutoSelect();
    this.logout(message);
  }
  logout(message?: string) {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    if (message)
      this.router.navigate(['/login'], { queryParams: { message: message } });
    else window.location.href = '/login';
  }
  getCurrentUser() {
    return this.http.get<any[]>(`${environment.baseUrl}/users/me`);
  }
  getCurrentUserInfo() {
    return jwt_decode(
      JSON.parse(localStorage.getItem('currentUser')!)?.credential
    );
  }
  getCurrentPermission(): any {
    return JSON.parse(localStorage.getItem('permissions')!)?.permissions || [];
  }
  getVisibility(page: keyof typeof environment.permissions) {
    let arr1 = environment.permissions[page];
    if (!arr1) return true;
    let arr2 = this.getCurrentPermission();
    return arr1.some((r) => {
      for (const element of arr2) {
        if (element.match(r)) return true;
      }
      return false;
    });
  }
}
